import { type FC } from "react";
import { type AvailableStartDayCassetteProps } from "@legacy_user_frontend/components/pages/mypage/profiles/profiles_show/src/profile_show_props";
import { changeDateFormat } from "@legacy_user_frontend/components/pages/mypage/profiles/profiles_show/src/module";
import * as styles from "../styles.css";

export const AvailableStartDayCassette: FC<AvailableStartDayCassetteProps> = ({
  availableStartDay: { isUndecided, availableStartDate, availableStartDateNote },
}) => (
  <div className={styles.tableList}>
    {(availableStartDate || isUndecided) && (
      <>
        <dt>勤務開始可能日</dt>
        <dd>
          {isUndecided && <>未定</>}
          {!isUndecided && <>{changeDateFormat(availableStartDate)}</>}
        </dd>
      </>
    )}
    {availableStartDateNote && (
      <>
        <dt>備考</dt>
        <dd>{availableStartDateNote}</dd>
      </>
    )}
  </div>
);
